import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WorkflowStep2Placeholder } from "src/app/models/workflow";

@Component({
    selector: 'app-personplaceholderlistitem',
    templateUrl: './personplaceholderlistitem.component.html'
  })
export class PersonPlaceholderListItemComponent {
  @Input('Placeholder') placeholder!: WorkflowStep2Placeholder;
  @Input('index') index!: number;
  @Input('showAddMyself') showAddMyself: boolean = false;
  @Output('addMyself') AddMyself = new EventEmitter();
  @Output('addPerson') AddPerson = new EventEmitter();
  @Output('PersonRemoved') personRemoved = new EventEmitter();
  @Output('PersonUpdated') personUpdated = new EventEmitter();
  @Output('DeletePlaceholder') DeletePlaceholder = new EventEmitter();

  constructor(private modalService: NgbModal) {
  }
    
  ngOnInit(): void {
    // ngOnInit must not be empty. It's approved by a comment.
  }

  addPerson(placeholderId: number) {
    this.AddPerson.emit(placeholderId);
  }

  addMyself(placeholderId: number) {
    this.AddMyself.emit(placeholderId);
  }

  deletePlaceholder(placeholderId: number) {
    this.DeletePlaceholder.emit(placeholderId);
  }
}